import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@mui/material";
import React from "react";
import { AvarezNosaziModel } from "../../../../Api/Models/AvarezNosaziModel";
import MDButton from "../../../../Components/MDButton";
import { ErrorToaast } from "../../../../utils/toast/Toast";
interface IDeleteRows {
  open: boolean;
  setClose: any;
  onDone: any;
  id: number;
}
export default function DeleteRow(props: IDeleteRows) {
  const avarezNosazi = new AvarezNosaziModel();
  function handleDelete() {
    avarezNosazi
      .delete(props.id)
      .then((r) => {
        props.onDone();
      })
      .catch((e) => ErrorToaast("خطا در برقراری ارتباط"));
  }
  return (
    <Dialog open={props.open} onClose={props.setClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">آیا از حذف عوارض مورد نظر اطمینان دارید؟</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          با حذف عوارض مورد نظر دیگر قابل مشاهده نمیباشد , ایا از انجام این کار اطمینان دارید؟
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <MDButton color="success" onClick={handleDelete}>
          حذف
        </MDButton>
        <MDButton onClick={props.setClose} autoFocus color="warning">
          بازگشت
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
